import React from "react";
import "./SectionHeading.scss";

export const SectionHeading = ({
  children,
  style = {},
  persistCenter = true,
}: {
  children: React.ReactNode;
  persistCenter?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <p
      className={`section-heading ${persistCenter ? "" : "text-align-start"}`}
      style={style}
    >
      {children}
    </p>
  );
};
